import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';
import { throwError } from 'rxjs';
import { NetworkState } from '../models/enums';

@Injectable({
	providedIn: 'root'
})
export class CustomToastService {

	constructor(private toast: ToastController,
				private translateService: TranslateService) {
	}

	async success(mesText, title = 'Success') {
		// const toast = await this.toast.create({
		// 	message: mesText, header: title,
		// 	position: 'top',
		// 	cssClass: 'toast-custom-class',
		// 	duration: 3000
		// });
		// await toast.present();
	}

	async inform(mesText) {
		const toast = await this.toast.create({
			message: mesText,
			position: 'middle',
			cssClass: 'toast-custom-class',
			duration: 1500,
			mode: 'ios',
		});
		await toast.present();
	}

	async danger(mesText, title = 'Error') {
		const toast = await this.toast.create({
			message: mesText,
			header: title,
			position: 'top',
			color: 'danger',
			duration: 3000,
		});
		await toast.present();
	}


	getMessage(type: NetworkState) {
		let res;
		switch (type) {
			case NetworkState.Connected:
				res = this.translateService.instant('network.connected');
				break;
			case NetworkState.Disconnected:
				res = this.translateService.instant('network.connection-problem');
				break;
			default: {
				return throwError('missing case for:' + type);
			}
		}

		return res;
	}
}
